import React, {Component, PropTypes} from 'react';
import Description from './description'
import Media from './media.js'
export default class Index extends Component {
  constructor() {
    super()
  }

 
  render() {

    return (
      <div className="container">
        <div className="row">
          <div className="col-sm-12">
            <Description/>
            <Media/>
          </div>
        </div>
      </div>
    );
  }
}



// WEBPACK FOOTER //
// ./app/screens/About/index.js